import * as JsonPatch from 'fast-json-patch';

import axios from '@/portainer/services/axios';
import { EnvironmentId } from '@/react/portainer/environments/types';
import { parseKubernetesAxiosError } from '@/react/kubernetes/axiosError';
import { buildKubernetesApiVersionUri } from '@/react/kubernetes/utils';
import { lowerCasePlural } from '@/react/common/string-utils';

export async function applyPatch(
  kind: string,
  apiVersion: string,
  environmentId: EnvironmentId,
  namespace: string,
  name: string,
  patch: JsonPatch.Operation[],
  plural?: string
) {
  try {
    const { data: deployment } = await axios.patch(
      buildUrl(kind, apiVersion, environmentId, namespace, name, plural),
      patch,
      {
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      }
    );
    return deployment;
  } catch (e) {
    throw parseKubernetesAxiosError(e, 'Unable to update YAML resource');
  }
}

function buildUrl(
  kind: string,
  apiVersion: string,
  environmentId: EnvironmentId,
  namespace: string,
  name: string,
  plural?: string
) {
  const resourcePrefix = lowerCasePlural(kind, plural);

  // Use shared utility to construct API path from apiVersion
  const apiVersionURI = buildKubernetesApiVersionUri(apiVersion);

  let url = `/endpoints/${environmentId}/kubernetes/${apiVersionURI}`;

  if (namespace) {
    url += `/namespaces/${namespace}`;
  }

  if (resourcePrefix && name) {
    url += `/${resourcePrefix}/${name}`;
  }

  url += `?fieldManager=kubectl`;

  return url;
}
